import { TenantSettingsPublicIntegrationsTrackSolidDto } from './tenant-settings-public-integrations-track-solid.dto';

export class TenantSettingsPublicGpsTrackersDto {
  isEnabled?: boolean | null;
  trackSolid?: TenantSettingsPublicIntegrationsTrackSolidDto | null;
}
